<template>
  <b-row>
    <b-col md="12">
      <div class="thank-img text-center">
        <img class="" src="@/assets/images/thanks.png" alt />
      </div>
      <h2 align="center" class="mt-3">Successfully Onboarded!</h2>
      <div style="text-align: center" class="mt-4">
        <b-button variant="outline-primary" @click="(e) => $emit('done')">Go Back To Tenant Listing</b-button>
      </div>
    </b-col>
  </b-row>

</template>
<script>
export default {
  name: "ThankYou",
};
</script>

<style scoepd>
.thank-img img {
  width: 450px;
}
</style>